<template>
    <div class="container mx-auto px-4">
        <div class="bg-highlight flex h-28 items-center justify-center mb-10 mx-auto rounded-lg w-28">
            <c-icon class="h-16 stroke-white w-16" icon="mail" />
        </div>

        <h1 class="font-serif mb-8 md:text-5xl text-2xl text-center">
            {{ __('Nézd meg az email fiókod.') }}
        </h1>
        <p class="mb-10 text-center text-slate-400 text-sm">
            {{ __('Küldtünk egy email amely tartalmazza a jelszó módosításához szükséges kódot.') }}
        </p>

        <input class="bg-white border border-slate-200 h-16 mb-5 mx-auto rounded-lg table text-center text-3xl tracking-widest w-96" autocomplete="off" name="code" placeholder="______" type="text"
               v-bind:class="{ 'border-error placeholder:text-red-300 text-error' : !!requestStore.errors?.code }"
               v-on:keydown="validateKey"
               v-on:input="validateInput"
               v-model="code"
        />

        <c-button class="bg-slate-800 border-2 border-slate-800 font-semibold hover:bg-highlight hover:border-highlight mb-4 mt-8 mx-auto normal-case px-4 py-2 rounded-none table text-center !text-lg text-white transition-colors w-48"
                  v-on:click="submit"
        >
            {{ __('Jelszó módosítása') }}
        </c-button>

        <p class="text-center text-sm">
            {{ __('Nem kaptál emailt? Ellenőrizd a spam mappát, vagy adj meg egy másik email címet.') }}
        </p>
    </div>
</template>

<script setup lang="ts">
    import { onMounted, ref } from 'vue';
    import { useRoute } from 'vue-router';
    import {
        CButton,
        CIcon,
    } from '@teamfurther/cinderblock';

    import { useRequestStore }  from '../../stores/request';
    import { useSessionStore } from '../../stores/session';

    const code = ref<string>('');
    const requestStore = useRequestStore();
    const route = useRoute();
    const email = route.query.email;
    const sessionStore = useSessionStore();

    function validateKey(e) {
        if (
            ['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'Tab'].includes(e.code) ||
            !isNaN(Number(e.key)) ||
            e.metaKey === true
        ) {
            return true;
        }

        e.preventDefault();
    }

    async function submit() {
        await sessionStore.setResetToken(code.value, email);
    }

    function validateInput(e) {
        e.target.value = e.target.value.replace(/[^0-9]*/g, '').substring(0, 6);
    }

    onMounted(() => {
        if (sessionStore.user) {
            requestStore.redirect({ name: 'errors.403' });
        }
    });
</script>
